// extracted by mini-css-extract-plugin
export default {"footerBtn":"PreCheckModal_footerBtn__qt+nm","card":"PreCheckModal_card__TuZEH","modal":"PreCheckModal_modal__CZ6Z-","modalRoot":"PreCheckModal_modalRoot__VH4v7"};